import { Title, Text, Grid, ThemeIcon, rem, Badge, Group, Container, Paper, Stack } from '@mantine/core';
import { motion } from 'framer-motion';
import BotDemo from '../../bot/BotDemo';
import { HOME_CONTENT } from '../../data/homeContent';

const MotionGridCol = motion.create(Grid.Col);
const MotionPaper = motion(Paper);

/**
 * Features component highlights the unique selling points of the bot management tool.
 * It includes an interactive demo and a detailed list of core functionalities.
 */
export default function Features() {
  const { features } = HOME_CONTENT;
  return (
    <Container size="lg" id="features" py={{ base: 80, md: 120 }}>
      {/* 1. Main Feature Split */}
      <Grid gutter={60} align="center" mb={20}>
        <MotionGridCol span={{ base: 12, md: 6 }} order={{ base: 2, md: 1 }} initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
           <BotDemo />
        </MotionGridCol>

        <MotionGridCol span={{ base: 12, md: 6 }} order={{ base: 1, md: 2 }} initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
          <Group mb="md"><Badge variant="gradient" gradient={{ from: 'indigo', to: 'cyan' }} size="md" radius="sm">{features.badge}</Badge></Group>
          <Title order={2} mb="md" fw={900} style={{ letterSpacing: '-1px' }}>
              <span style={{ color: '#228be6' }}>{features.title}</span> {features.titleHighlight}
          </Title>
          <Text c="dimmed" mb="xl" size="lg" lh={1.6}>{features.description}</Text>

          <Stack gap="md">
              {features.items.map((feature, i) => (
                  <MotionPaper key={i} p="md" radius="md" style={{ backgroundColor: 'rgba(255, 255, 255, 0.03)', border: '1px solid rgba(255, 255, 255, 0.05)' }} whileHover={{ x: 5, backgroundColor: 'rgba(255,255,255,0.05)' }}>
                      <Group wrap="nowrap" align="flex-start">
                          <ThemeIcon size={44} radius="md" variant="light" color={feature.color} style={{ flexShrink: 0 }}><feature.icon style={{ width: rem(24) }} /></ThemeIcon>
                          <div>
                              <Text fw={700} c="white" size="lg" mb={4}>{feature.title}</Text>
                              <Text size="sm" c="dimmed" lh={1.5}>{feature.desc}</Text>
                          </div>
                      </Group>
                  </MotionPaper>
              ))}
          </Stack>
        </MotionGridCol>
      </Grid>
    </Container>
  );
}